import { Comment } from '../models/comment'

export const isAccepted = (comment: Comment) => comment.acceptedAt != null
export const isRejected = (comment: Comment) => comment.rejectedAt != null
export const isUnmoderated = (comment: Comment) =>
  comment.acceptedAt == null && comment.rejectedAt == null
